// Кольорова палітра TransCaspian
export const colors = {
  // Основні кольори
  mainOrange: '#FF561E',
  mainOrangeLight: '#FF9361',
  mainBlack: '#1e1e1e',
  mainWhite: '#FFFFFF',

  // Градієнти
  mainGradient: 'linear-gradient(135deg, #FF561E 0%, #FF9361 100%)',
  secondaryGradient: 'linear-gradient(135deg, #FF561E 0%, #862100 100%)',

  // Сірі кольори
  heavyGray: '#8A8A73',
  goldGrey: '#e3e3e3',

  // Додаткові кольори для UI
  lightGray: '#f8f9fa',
  borderGray: '#dee2e6',
  textGray: '#666',
  textDark: '#333',

  // Hover стани
  mainOrangeHover: '#e6450a',
  mainOrangeLightHover: '#ff7a3d',
};

// Експорт для використання в styled-components
export default colors;

